(function () {
  if (window.__belnayQuickViewBound) return;
  window.__belnayQuickViewBound = true;

  var modal = document.querySelector('[data-quick-view-modal]');
  if (!modal) return;
  /* The shell starts natively hidden so it cannot flash before its stylesheet. */
  modal.hidden = false;

  var dialog = modal.querySelector('.quick-view__dialog');
  var content = modal.querySelector('[data-quick-view-content]');
  var closeButtons = modal.querySelectorAll('[data-quick-view-close]');
  var cache = {};
  var activeRequest = null;
  var lastTrigger = null;
  var currentUrl = '';
  var openedByPointer = false;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function loadingMarkup() {
    return (
      '<div class="quick-view__loading" aria-live="polite">' +
        '<span class="quick-view__loading-line"></span>' +
        '<span class="quick-view__loading-line"></span>' +
        '<span class="visually-hidden">Loading product</span>' +
      '</div>'
    );
  }

  function errorMarkup(url) {
    return (
      '<div class="quick-view__error">' +
        '<p>We could not load this product.</p>' +
        '<a href="' + escapeHtml(url) + '">View the product page</a>' +
      '</div>'
    );
  }

  function openModal(trigger, fromPointer) {
    var url = trigger.getAttribute('data-product-url');
    if (!url) return;

    openedByPointer = !!fromPointer;
    modal._bundleLine = trigger.closest('[data-bundle-line]') || null;
    modal.hidden = false;
    lastTrigger = trigger;
    currentUrl = url;
    modal.classList.add('is-open', 'is-loading');
    modal.setAttribute('aria-hidden', 'false');
    if (window.Belnay && typeof window.Belnay.lockPageScroll === 'function') {
      window.Belnay.lockPageScroll('quick-view');
    }
    document.body.classList.add('quick-view-open');
    content.setAttribute('aria-busy', 'true');
    content.innerHTML = loadingMarkup();

    window.requestAnimationFrame(function () {
      var close = modal.querySelector('.quick-view__close');
      if (close) close.focus({ preventScroll: true });
    });

    if (activeRequest && activeRequest.abort) activeRequest.abort();
    activeRequest = null;

    if (cache[url]) {
      paintProduct(cache[url], url);
      return;
    }

    activeRequest = 'AbortController' in window ? new AbortController() : null;
    var separator = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + separator + 'view=quickview', {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
      signal: activeRequest ? activeRequest.signal : undefined
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed');
        return response.text();
      })
      .then(function (html) {
        if (!html.trim()) throw new Error('Product response was empty');
        cache[url] = html;
        if (modal.classList.contains('is-open') && currentUrl === url) paintProduct(html, url);
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        if (!modal.classList.contains('is-open') || currentUrl !== url) return;
        modal.classList.remove('is-loading');
        content.removeAttribute('aria-busy');
        content.innerHTML = errorMarkup(url);
      });
  }

  function closeModal() {
    if (window.Belnay && typeof window.Belnay.closeSizeCharts === 'function') {
      window.Belnay.closeSizeCharts();
    }
    document.querySelectorAll('body > [data-size-chart-layer][data-size-chart-host="quick-view"]').forEach(function (layer) {
      layer.remove();
    });
    modal.classList.remove('is-open', 'is-loading');
    modal.setAttribute('aria-hidden', 'true');
    content.removeAttribute('aria-busy');
    document.body.classList.remove('quick-view-open');
    if (window.Belnay && typeof window.Belnay.unlockPageScroll === 'function') {
      window.Belnay.unlockPageScroll('quick-view');
    }
    currentUrl = '';
    modal._bundleLine = null;
    if (activeRequest && activeRequest.abort) activeRequest.abort();
    activeRequest = null;

    window.setTimeout(function () {
      if (!modal.classList.contains('is-open')) content.innerHTML = loadingMarkup();
    }, reducedMotion ? 0 : 470);

    var trigger = lastTrigger;
    lastTrigger = null;
    if (trigger && document.contains(trigger) && typeof trigger.focus === 'function') {
      trigger.focus({ preventScroll: true });
      if (openedByPointer) trigger.blur();
    }
    openedByPointer = false;
  }

  function paintProduct(html, url) {
    content.innerHTML = html;
    content.removeAttribute('aria-busy');
    modal.classList.remove('is-loading');
    var productRoot = content.querySelector('[data-quick-view-product]');
    bindProduct(productRoot, url);
    if (modal._bundleLine && productRoot) {
      var quantity = productRoot.querySelector('.quick-view-product__quantity');
      var fullLink = productRoot.querySelector('.quick-view-product__full-link');
      if (quantity) quantity.hidden = true;
      if (fullLink) fullLink.hidden = true;
      var choose = productRoot.querySelector('[data-quick-view-add]');
      if (choose && !choose.disabled) choose.textContent = chooseLabel();
    }
    if (window.Belnay && typeof window.Belnay.bindAccordions === 'function') {
      window.Belnay.bindAccordions(content);
    }
    if (window.Belnay && typeof window.Belnay.bindSizeChart === 'function') {
      window.Belnay.bindSizeChart(content);
    }
  }

  function formatMoney(cents) {
    var format = modal.getAttribute('data-money-format') || '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, format).replace(/[^\d.,]/g, '');
      } catch (error) {}
    }
    var amount = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    return amount;
  }

  function bindProduct(root, url) {
    if (!root) {
      content.innerHTML = errorMarkup(url);
      return;
    }

    var jsonNode = root.querySelector('[data-quick-view-product-json]');
    var product = null;
    try {
      product = jsonNode ? JSON.parse(jsonNode.textContent) : null;
    } catch (error) {
      product = null;
    }

    root.querySelectorAll('[data-quick-view-swatch]').forEach(function (swatch) {
      swatch.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        var scroller = swatch.closest('.quick-view__dialog, .quick-view__content') || document.scrollingElement;
        var top = scroller ? scroller.scrollTop : 0;
        requestAnimationFrame(function () {
          if (scroller && scroller.scrollTop !== top) scroller.scrollTop = top;
        });
      });
    });

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-quick-view-thumb]');
      if (thumb) {
        showImage(root, parseInt(thumb.getAttribute('data-quick-view-thumb'), 10) || 0);
        return;
      }

      var swatch = event.target.closest('[data-quick-view-swatch]');
      if (swatch) {
        var index = parseInt(swatch.getAttribute('data-option-index'), 10);
        var select = root.querySelectorAll('[data-quick-view-option]')[index];
        if (!select) return;
        select.value = swatch.getAttribute('data-value');
        swatch.parentElement.querySelectorAll('[data-quick-view-swatch]').forEach(function (item) {
          var selected = item === swatch;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var label = root.querySelector('[data-quick-view-colour]');
        if (label) label.textContent = swatch.getAttribute('data-value');
        updateVariant(root, product);
        return;
      }

      var sizeBtn = event.target.closest('[data-quick-view-size]');
      if (sizeBtn) {
        var sizeIndex = parseInt(sizeBtn.getAttribute('data-option-index'), 10);
        var sizeSelect = root.querySelectorAll('[data-quick-view-option]')[sizeIndex];
        if (!sizeSelect) return;
        sizeSelect.value = sizeBtn.getAttribute('data-value');
        sizeBtn.parentElement.querySelectorAll('[data-quick-view-size]').forEach(function (item) {
          var selected = item === sizeBtn;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        updateVariant(root, product);
        return;
      }

      var quantityButton = event.target.closest('[data-quick-view-quantity]');
      if (quantityButton) {
        var quantityInput = root.querySelector('[data-quick-view-quantity-input]');
        var current = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
        var delta = parseInt(quantityButton.getAttribute('data-quick-view-quantity'), 10) || 0;
        if (quantityInput) quantityInput.value = String(Math.max(1, current + delta));
        return;
      }

      var addButton = event.target.closest('[data-quick-view-add]');
      if (addButton && !addButton.disabled) {
        addProduct(root, addButton);
      }
    });

    root.querySelectorAll('[data-quick-view-option]').forEach(function (select) {
      select.addEventListener('change', function () {
        updateVariant(root, product);
      });
    });

    updateVariant(root, product);
  }

  function revealQuickViewMedia(root, variant) {
    if (!root || !variant) return;
    var media = variant.featured_media;
    var id = media && media.id ? String(media.id) : '';
    if (!id && variant.featured_image && variant.featured_image.id) id = String(variant.featured_image.id);
    if (!id) return;
    var match = root.querySelector('[data-quick-view-slide][data-media-id="' + id + '"]');
    if (!match) return;
    var active = root.querySelector('[data-quick-view-slide].is-active');
    if (match === active) return;
    var stage = root.querySelector('.quick-view-product__stage');
    var from = active && active.querySelector('img');
    var ghost = null;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (stage && from && !reduced) {
      var oldGhost = stage.querySelector('[data-color-ghost]');
      if (oldGhost) oldGhost.remove();
      ghost = from.cloneNode(true);
      ghost.removeAttribute('id');
      ghost.setAttribute('alt', '');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.setAttribute('data-color-ghost', '');
      ghost.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;z-index:2;pointer-events:none;margin:0;opacity:1;transition:opacity 250ms ease-in-out;';
      stage.appendChild(ghost);
    }
    match.style.animation = 'none';
    showImage(root, parseInt(match.getAttribute('data-quick-view-slide'), 10) || 0);
    window.setTimeout(function () { match.style.animation = ''; }, 320);
    if (!ghost) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        ghost.style.opacity = '0';
      });
    });
    window.setTimeout(function () {
      if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
    }, 280);
  }

  function showImage(root, index) {
    root.querySelectorAll('[data-quick-view-slide]').forEach(function (slide) {
      var active = parseInt(slide.getAttribute('data-quick-view-slide'), 10) === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });
    root.querySelectorAll('[data-quick-view-thumb]').forEach(function (thumb) {
      var active = parseInt(thumb.getAttribute('data-quick-view-thumb'), 10) === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }

  function updateVariant(root, product) {
    if (!product || !product.variants) return;
    var selected = Array.prototype.map.call(
      root.querySelectorAll('[data-quick-view-option]'),
      function (select) { return select.value; }
    );
    var variant = product.variants.find(function (candidate) {
      return selected.every(function (value, index) {
        return candidate.options[index] === value;
      });
    });
    if (!variant) return;

    var variantInput = root.querySelector('[data-quick-view-variant]');
    var price = root.querySelector('[data-quick-view-price]');
    var compare = root.querySelector('[data-quick-view-compare]');
    var stock = root.querySelector('[data-quick-view-stock]');
    var add = root.querySelector('[data-quick-view-add]');

    if (variantInput) variantInput.value = variant.id;
    if (price) price.textContent = formatMoney(variant.price);
    if (compare) {
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = variant.compare_at_price ? formatMoney(variant.compare_at_price) : '';
    }
    if (stock) {
      stock.textContent = variant.available ? 'Low in stock' : 'Sold out';
      stock.classList.toggle('is-sold-out', !variant.available);
    }
    if (add) {
      add.disabled = !variant.available;
      if (modal._bundleLine) {
        add.textContent = variant.available ? chooseLabel() : soldLabel();
      } else {
        add.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }
    paintPhotoBadge(root, variant);
    revealQuickViewMedia(root, variant);

    var chosen = selected;
    root.querySelectorAll('[data-quick-view-size]').forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-option-index'), 10);
      var value = btn.getAttribute('data-value');
      var available = product.variants.some(function (candidate) {
        if (candidate.available === false) return false;
        return candidate.options.every(function (opt, i) {
          if (i === idx) return opt === value;
          return chosen[i] === opt;
        });
      });
      btn.classList.toggle('is-unavailable', !available);
    });
  }

  function chooseLabel() {
    return modal.getAttribute('data-choose-label') || 'Use this piece';
  }

  function soldLabel() {
    return modal.getAttribute('data-sold-label') || 'Sold out';
  }

  function saleBadgeLabel() {
    return modal.getAttribute('data-sale-badge') || '-{percent}%';
  }

  function paintPhotoBadge(root, variant) {
    if (!root || !variant) return;
    var compare = Number(variant.compare_at_price) || 0;
    var price = Number(variant.price) || 0;
    var pct = compare > price ? Math.round(((compare - price) / compare) * 100) : 0;
    root.querySelectorAll('[data-sale-badge]').forEach(function (badge) {
      if (variant.available === false) {
        badge.hidden = false;
        badge.textContent = soldLabel();
      } else if (pct > 0) {
        badge.hidden = false;
        badge.textContent = saleBadgeLabel().replace('{percent}', String(pct));
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }

  function productFrom(root) {
    var jsonNode = root.querySelector('[data-quick-view-product-json]');
    try {
      return jsonNode ? JSON.parse(jsonNode.textContent) : null;
    } catch (error) {
      return null;
    }
  }

  function euList(root) {
    try {
      var list = JSON.parse(root.getAttribute('data-quick-view-eu') || 'null');
      return Array.isArray(list) ? list : null;
    } catch (error) {
      return null;
    }
  }

  function addProduct(root, button) {
    var variant = root.querySelector('[data-quick-view-variant]');
    var quantity = root.querySelector('[data-quick-view-quantity-input]');
    var id = variant && variant.value;
    if (modal._bundleLine && document.contains(modal._bundleLine)) {
      var picked = productFrom(root);
      if (!picked || !id) return;
      var euPick = root.querySelector('[data-quick-view-size][data-eu].is-selected');
      document.dispatchEvent(new CustomEvent('belnay:bundle-apply', {
        detail: {
          line: modal._bundleLine,
          product: picked,
          variantId: Number(id),
          // EU sizes (docs/SIZE_CHARTS.md): the line lists them and keeps the one picked here.
          eu: euList(root),
          pick: euPick ? euPick.getAttribute('data-eu') : ''
        }
      }));
      closeModal();
      return;
    }
    var count = Math.max(1, parseInt(quantity && quantity.value, 10) || 1);
    if (!id || !window.BelnayCart || typeof window.BelnayCart.add !== 'function') return;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (typeof window.BelnayFlyToCart === 'function') window.BelnayFlyToCart(button);

    var euBtn = root.querySelector('[data-quick-view-size][data-eu].is-selected');
    var advice = window.Belnay && window.Belnay.sizeAdvice ? window.Belnay.sizeAdvice(root) : '';
    var props = euBtn && window.BelnayCart.euProps ? window.BelnayCart.euProps(euBtn.getAttribute('data-eu'), euBtn.getAttribute('data-value'), advice) : null;
    window.BelnayCart.add(id, count, props ? { keepOpen: true, properties: props } : { keepOpen: true })
      .then(function () {
        closeModal();
        window.BelnayCart.open();
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Add to cart';
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-view-open]');
    if (!trigger) return;
    event.preventDefault();
    openModal(trigger, event.detail > 0);
  });

  content.addEventListener('click', function (event) {
    if (!modal._bundleLine) return;
    var link = event.target.closest('a[href]');
    if (link) event.preventDefault();
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (!modal.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      closeModal();
      return;
    }
    if (event.key !== 'Tab' || !dialog) return;

    var focusable = dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
